import { CmsService, mergeServices } from '../../data/cms';
import { useCms } from './Cms';

export function useServiceCatalog() {
  const result = useCms<CmsService[]>('/service-items');
  const cmsServices = Array.isArray(result.data) ? result.data : [];
  return { ...result, cmsServices, services: mergeServices(cmsServices) };
}
